import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Alert } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

export class BusinessErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, retryCount: 0 };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('❌ BusinessErrorBoundary error:', error);
    console.error('❌ Message:', error?.message);
    console.error('❌ Stack:', error?.stack);
    console.error('❌ Component stack:', errorInfo?.componentStack);
    this.setState({ error, errorInfo });
  }

  handleRetry = () => {
    this.setState(prevState => ({
      hasError: false,
      error: null,
      errorInfo: null,
      retryCount: prevState.retryCount + 1,
    }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 20 }}>
          <Ionicons name="warning-outline" size={64} color="#ff6b6b" />
          <Text style={{ fontSize: 20, fontWeight: 'bold', marginTop: 16, marginBottom: 8 }}>
            Business Crash
          </Text>
          <Text style={{ textAlign: 'center', marginBottom: 24 }}>
            {this.state.error?.message || 'Unknown error in BusinessProvider'}
          </Text>
          <TouchableOpacity 
            style={{ backgroundColor: '#007AFF', paddingHorizontal: 20, paddingVertical: 10, borderRadius: 8 }}
            onPress={this.handleRetry}
          >
            <Text style={{ color: 'white', fontWeight: '600' }}>Try Again</Text>
          </TouchableOpacity>
        </View>
      );
    }
    return this.props.children;
  }
}

export const withErrorHandling = (WrappedComponent, screenName) => {
  return function ErrorHandledComponent(props) {
    return (
      <BusinessErrorBoundary screenName={screenName}>
        <WrappedComponent {...props} />
      </BusinessErrorBoundary>
    );
  };
};
